import * as React from 'react';
import SvgIcon from '../svg-icon/SvgIcon';

export const CloseIcon = (props) => {
    const {stroke = "#FFF"} = props;
  return (
    <SvgIcon {...props} width="18.828" height="18.828" viewBox="0 0 18.828 18.828" fontSize="small">
      <path id="Path_657" data-name="Path 657" d="M342,166l16-16m-16,0,16,16" transform="translate(-340.586 -148.586)"
            fill="none" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
    </SvgIcon>
  );
};

export default CloseIcon;
